module.exports = __webpack_public_path__ + "media/nye-r.ded281e4.mp4";